module.exports = __webpack_public_path__ + "img/logo-01 kontan-01.4d59f5bb.png";